import { useState, useRef, React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

function CountDaysInput(props) {
	const { className, placeholder, value, setValue, type } = props;
	const { t } = useLanguage();

	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	function handleClick(e) {
		inputRef.current.style.borderColor = '#FF8B48';
	}

	function handleChange(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");

		if (result === '') setValue(0);
    else if (result < 9999999) setValue(parseInt(result));
		setChanged(true);
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = '#B2B2B2';
	}

	return (
    <TopLevelWrapper>
      <Input
        ref={inputRef}
        clickCount={clickCount}
        type={type}
        placeholder={defaultPlaceholder}
        value={value}
        changedColor={changedPlaceholderColor}
        className={`${className} ${changed ? "changed" : ""}`}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
        <Text>{t('main.locker.dayUnit')}</Text>
    </TopLevelWrapper>
  )
}

export default CountDaysInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #000000;

  margin: 0 0 0 0;
`;

const Input = styled.input`
  text-align: right;
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	padding: 0 8px 0 8px;

  width: 98px;
  height: 30px;

	outline: none;
  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #FFFFFF;

	color: #000000;

	::placeholder {
		color: ${props => props.changedColor ? `#FF3131` : `#CBCBCB`};
	}

  transition: all 0.3s ease-in-out;
`;
